import React from 'react';
import McpAccessStatus from '../components/McpAccessStatus.js';
import { Mail, MessageCircle, ExternalLink, HelpCircle } from 'lucide-react';

export default function SettingsPage() {
  return (
    <div style={{ maxWidth: 640, margin: '0 auto' }}>
      <h2 className="page-title">Settings</h2>
      <p className="page-subtitle" style={{ marginBottom: 24 }}>
        Account preferences and support resources.
      </p>

      <McpAccessStatus />

      {/* Help & Support Section */}
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{
          padding: '14px 18px',
          borderBottom: '1px solid var(--border)',
          display: 'flex', alignItems: 'center', gap: 8,
        }}>
          <HelpCircle size={16} style={{ color: 'var(--orange)' }} />
          <span style={{ fontSize: 'var(--text-sm)', fontWeight: 600, color: 'var(--text)' }}>
            Help &amp; Support
          </span>
        </div>

        <div style={{ padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          {/* Support email */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
            <Mail size={14} style={{ color: 'var(--text-muted)', marginTop: 3, flexShrink: 0 }} />
            <div>
              <div style={{ fontSize: 'var(--text-sm)', color: 'var(--text)', marginBottom: 4 }}>
                Email Support
              </div>
              <a
                href="mailto:support@ocnexus.dev"
                style={{ fontSize: 'var(--text-xs)', color: 'var(--orange)', textDecoration: 'none' }}
              >
                support@ocnexus.dev
              </a>
              <p style={{ fontSize: 'var(--text-xs)', color: 'var(--text-muted)', marginTop: 4, lineHeight: 1.5 }}>
                For billing questions, account issues, or detailed bug reports.
                Responses are typically within 24 hours.
              </p>
            </div>
          </div>

          {/* Chat widget */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
            <MessageCircle size={14} style={{ color: 'var(--text-muted)', marginTop: 3, flexShrink: 0 }} />
            <div>
              <div style={{ fontSize: 'var(--text-sm)', color: 'var(--text)', marginBottom: 4 }}>
                Live Chat Widget
              </div>
              <button
                onClick={() => (window as any).LumenIQSupport?.open()}
                style={{
                  background: 'none', border: 'none', cursor: 'pointer', padding: 0,
                  fontSize: 'var(--text-xs)', color: 'var(--orange)', textDecoration: 'underline',
                  fontFamily: 'inherit',
                }}
              >
                Open support chat
              </button>
              <p style={{ fontSize: 'var(--text-xs)', color: 'var(--text-muted)', marginTop: 4, lineHeight: 1.5 }}>
                Use the chat widget in the bottom-right corner of any page for quick questions
                or to report issues in real time.
              </p>
            </div>
          </div>

          {/* Reporting guidance */}
          <div style={{
            padding: '12px 14px', background: 'var(--surface2)',
            borderRadius: 'var(--radius-md)', border: '1px solid var(--border)',
          }}>
            <div style={{
              fontSize: 'var(--text-xs)', fontWeight: 600, color: 'var(--text-dim)',
              marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.04em',
            }}>
              Reporting a bug?
            </div>
            <p style={{ fontSize: 'var(--text-xs)', color: 'var(--text-muted)', lineHeight: 1.6, margin: 0 }}>
              To help us resolve issues quickly, please include:
            </p>
            <ul style={{
              fontSize: 'var(--text-xs)', color: 'var(--text-muted)', lineHeight: 1.8,
              margin: '6px 0 0', paddingLeft: 18,
            }}>
              <li>The <strong style={{ color: 'var(--text-dim)' }}>pipeline run ID</strong> (visible on the run detail page)</li>
              <li>The <strong style={{ color: 'var(--text-dim)' }}>executor type</strong> (Claude, Codex, etc.)</li>
              <li>The <strong style={{ color: 'var(--text-dim)' }}>error message</strong> or stack trace</li>
              <li>Steps to reproduce, if applicable</li>
            </ul>
          </div>

          {/* Documentation link */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
            <ExternalLink size={14} style={{ color: 'var(--text-muted)', marginTop: 3, flexShrink: 0 }} />
            <div>
              <div style={{ fontSize: 'var(--text-sm)', color: 'var(--text)', marginBottom: 4 }}>
                Documentation
              </div>
              <a
                href="https://ocnexus.dev/docs"
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: 'var(--text-xs)', color: 'var(--orange)', textDecoration: 'none' }}
              >
                ocnexus.dev/docs <ExternalLink size={10} style={{ verticalAlign: 'middle' }} />
              </a>
              <p style={{ fontSize: 'var(--text-xs)', color: 'var(--text-muted)', marginTop: 4, lineHeight: 1.5 }}>
                Guides, API reference, and pipeline configuration documentation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
